import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import CssBaseline from "@mui/material/CssBaseline";

import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import "./assets/css/knowledgebase.css";

import App from "./App";

import { store } from "./store";
import { AppProvider } from "./contexts/AppContext";
ReactDOM.render(
  <React.StrictMode>
    <CssBaseline />

    <BrowserRouter>
      <Provider store={store}>
        <AppProvider>
            <App />
        </AppProvider>
      </Provider>
    </BrowserRouter>
    <ToastContainer hideProgressBar position="top-center" autoClose={2000} />
  </React.StrictMode>,

  document.getElementById("root")
);
